export enum Alert {
  Warning = 'warning',
  Danger = 'danger',
  Info = 'info',
  Success = 'success',
  Caution = 'caution'
}
